// Runtime Sentry environment from the hostname. The portal never set
// `environment`, so staging (dev-portal) and localhost traffic reported as
// environment:production and polluted triage (e.g. PORTAL-CLIENT-6PP/6PK are
// dev-portal, 5ZK/6P7 are localhost).
//
// Loopback AND private/dev hosts (LAN IPs, 0.0.0.0, *.local, *.localhost) map to
// 'development' — a dev session reached over the LAN or an mDNS name must not
// read as production. Only unrecognized PUBLIC hostnames stay 'production', so
// existing environment:production searches/alerts keep matching real production.
// CommonJS on purpose, same as sentryAxiosFingerprint.js (see
// sentryEnvironment.verify.js).

// IPv4 octet, 0–255.
const OCTET = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)'
// Loopback and RFC1918 private IPv4, matched as full IP addresses (not string
// prefixes) so a public host like "10.example.com" is NOT treated as private.
const LOOPBACK_IPV4_RE = new RegExp(`^127\\.${OCTET}\\.${OCTET}\\.${OCTET}$`)
const PRIVATE_10_RE = new RegExp(`^10\\.${OCTET}\\.${OCTET}\\.${OCTET}$`)
const PRIVATE_192_168_RE = new RegExp(`^192\\.168\\.${OCTET}\\.${OCTET}$`)
const PRIVATE_172_RE = new RegExp(`^172\\.(?:1[6-9]|2\\d|3[01])\\.${OCTET}\\.${OCTET}$`)

// Loopback, mDNS (*.local) and RFC1918 private hosts — the addresses a dev box is
// reached by. (IP link-local ranges like 169.254/16 and fe80:: are not matched.)
function isLocalOrPrivateHost(h) {
  if (h === 'localhost' || h.endsWith('.localhost')) return true
  if (h === '0.0.0.0' || h === '::1' || h === '[::1]') return true
  if (h.endsWith('.local')) return true
  return (
    LOOPBACK_IPV4_RE.test(h) ||
    PRIVATE_10_RE.test(h) ||
    PRIVATE_192_168_RE.test(h) ||
    PRIVATE_172_RE.test(h)
  )
}

function detectEnvironment(hostname) {
  const h = String(
    hostname !== undefined
      ? hostname
      : (typeof window !== 'undefined' && window.location && window.location.hostname) || ''
  ).toLowerCase()
  if (isLocalOrPrivateHost(h)) return 'development'
  if (h === 'dev-portal.holisticindustries.net') return 'staging'
  return 'production'
}

module.exports = { detectEnvironment }
